import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  "https://imqusqryzsvigmkwawre.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImltcXVzcXJ5enN2aWdta3dhd3JlIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI5MTA0MTIsImV4cCI6MjAwODQ4NjQxMn0.u6EoiO7CTLKdOBVCrU5mBSgLbvCy4fBWMI984yGXbqo"
);

export default supabase;